import React from 'react';

import { StyleSheet, useWindowDimensions } from 'react-native';

import { Box, BoxProps } from 'components/ui';
import { spacing } from 'styles/constants';
import { breakpoints } from 'styles/constants/breakpoints';

export const LogosContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.logosContainer, style] });

export const DividerLogos = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.dividerLogos, style] });

export const HeaderContainer = ({ style, ...props }: BoxProps) => {
  const { width } = useWindowDimensions();
  const isSmallOrLarger = width >= breakpoints.sm;
  const isDesktop = width >= breakpoints.md;

  return React.createElement(Box, {
    ...props,
    style: [
      styles.headerContainer,
      isSmallOrLarger && styles.headerContainerSmall,
      isDesktop && styles.headerContainerDesktop,
      style,
    ],
  });
};

const styles = StyleSheet.create({
  logosContainer: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
    marginBottom: spacing.$8,
    marginTop: spacing.$4,
  },
  dividerLogos: {
    borderColor: '#c5bcb0',
    borderLeftWidth: 2,
    borderStyle: 'solid',
    height: spacing.$10,
    marginLeft: spacing.$4,
    marginRight: spacing.$3,
    width: spacing.$2,
  },
  headerContainer: {
    alignSelf: 'center',
    height: 200,
    overflow: 'hidden',
    width: '100%',
  },
  headerContainerSmall: {
    height: 350,
  },
  headerContainerDesktop: {
    borderRadius: 10,
    height: 456,
    width: 912,
  },
});
